import _cloneDeep from 'lodash/cloneDeep';

/* @ngInject */
export default class DeviceTypeFilterController {
    constructor($scope, filters, onUpdateFilters, onClose) {
        this.$scope = $scope;
        this.filters = filters;
        this.onUpdateFilters = onUpdateFilters;
        this.onClose = onClose;
    }

    $onInit() {
        // Filters are passed in from the parent, no need to setup
    }

    close() {
        this.onClose();
    }

    apply() {
        // Pass the updated filters back to the parent and close
        this.onUpdateFilters(_cloneDeep(this.filters));
        this.close();
    }

    clear() {
        // Deactivate all device type filters
        this.filters.forEach(filter => {
            filter.active = false;
        });
        this.apply();
    }
}

